<template>
  <div class="top-header" >
    <!-- <div class="paraller" >
      <div class="container   clearfix" >
        <ul class="topbar">
          <li class="topbar-item" ><a>问题反馈</a></li>
          <li class="topbar-item" ><a>企业中心</a></li>
          <li class="topbar-item" ><a>人才中心</a></li>
        </ul>
      </div>
    </div> -->
    <div class="paraller" >
      <div class="container   clearfix" >
        <a href="/" ><img class="logo" src="../assets/img/logo-white.png" /></a>
        <!-- <div class="top-nav" >
          <ul>
            <li class="top-nav-item" ><a href="/home.html" >搜索 Search</a></li>
            <li class="top-nav-item" ><a href="/search.html" >找人、找工作</a></li>
          </ul>
        </div> -->
        <div class="top-side" >
          <ul>
            <li class="top-side-item" >
              <a href="/profile.html#/user" v-if="user_info.email" >{{user_info.email}}</a>
              <a href="/profile.html#/login" v-else  >登录</a>
            </li>
            <!-- <li class="top-side-item" ><a>找工作</a></li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },
  computed: {
    user_info() {
      return this.$store.state.user_info;
    }
  },
  mounted() { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="postcss" >
.paraller {
  border-top: 1px solid rgba(200, 200, 200, 0.1);
  border-bottom: 1px solid rgba(200, 200, 200, 0.1);
  margin: 0 auto;
}
.top-header {
  // background: #051d3b;
  color: #fff;
  background: linear-gradient(90deg, #051d3b, #06264d);
  margin: 0 auto;
  position: relative;
  & .container {
    // border-bottom: 1px solid #eee;
    // border-top: 1px solid rgba(255, 255, 255, 0.4);
  }
}
.topbar {
  margin-left: 0px;
}

.topbar-item {
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
  float: left;
  text-align: center;
  font-size: 12px;
  padding: 4px;
}
.top-side {
  float: right;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  &-item {
    display: inline;
    margin: 0 10px;
    color: #fff;
    & a {
      color: #fff;
    }
    & a:visited {
      color: #eee;
    }
  }
}
.top-nav {
  flex: 1;
  color: #fff;
  text-align: left;
  float: left;
  margin-left: 60px;
  height: 60px;
  line-height: 60px;

  &-item {
    display: inline;
    margin: 0 10px;
    & a {
      color: #fff;
    }
  }
}
.logo {
  height: 20px;
  margin: 20px;
  float: left;
}
.welcome-text {
  color: #333;
  text-align: center;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// TopHeader.vue?8afb5954